import React from 'react';

type SimpleTab = {
  name: string;
};

type Props = {
  tabs: SimpleTab[];
  onSelectTab: (name: string) => void;
  selectedTab: string;
};

const SimpleTabs: React.FC<Props> = ({ tabs, onSelectTab, selectedTab }) => {
  return (
    <div className="bg-white dark:bg-dark-gray-900">
      <div className="border-b border-gray-300 dark:border-dark-gray-700 px-6 overflow-x-auto overflow-y-hidden">
        <nav className="-mb-px flex mx-auto">
          {(tabs || []).map(tab => (
            <div
              key={tab.name}
              onClick={() => onSelectTab(tab.name)}
              className={[
                'whitespace-nowrap mr-6 py-4 px-1 border-b-2 border-transparent font-medium text-sm leading-5 text-gray-500 dark:text-dark-gray-400 cursor-pointer',
                selectedTab === tab.name
                  ? 'border-primary-500 font-medium text-sm leading-5 text-primary-600 focus:outline-none'
                  : 'hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600 focus:outline-none focus:text-gray-700 focus:border-gray-300',
              ].join(' ')}
            >
              {tab.name}
            </div>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default SimpleTabs;
